import {
    Card,
    CardImg,
    CardTitle,
    Col,
    Input,
    InputGroup,
    Modal,
    ModalHeader,
    Badge
} from "reactstrap";
import React, {useState} from "react";
import {ButtonTableDelete, ButtonTableEdit} from "../buttons/buttonsActions";

export const GalleryElement = (props) => {
    const [galleryActivityId] = useState( props.item.id );
    const [url] = useState( props.item.url );
    const [fileName] = useState( props.item.fileName );
    const [media] = useState( props.item.media );
    const [mediaDefault, setMediaDefault] = useState( props.item.mediaDefault );

    const [modal, setModal] = useState(false);

    const toggleModal = () => {
        setModal(!modal);
    }

    const onClickDelete = () => {
        props.sendDelete(galleryActivityId);
    }

    const onClickEdit = () => {
        props.sendEdit(galleryActivityId);
    }

    const onChange = () => {
        setMediaDefault(!mediaDefault);
        props.sendDefault(galleryActivityId, media.id, !mediaDefault);
    }

    return  (
        <Col xs="12" lg="3" >
            <Card >
                {
                    mediaDefault && <Badge color="danger">Imagen principal</Badge>
                }
                <CardImg top width="100%" src={url} alt="Card image cap" onClick={toggleModal} />
                <Modal isOpen={modal} toggle={toggleModal} >
                    <ModalHeader toggle={toggleModal}>
                        <i className="mdi mdi-camera-iris"/> {fileName}
                    </ModalHeader>
                    <img src={url} alt="" width="100%" />
                </Modal>
                <CardTitle className="bg-light border-bottom text-center mb-0">
                    <InputGroup>
                        <Input type="text" value={fileName} readOnly />
                        <ButtonTableEdit onClick={onClickEdit} />
                        {
                            !props.item.isMain && <ButtonTableDelete onClick={onClickDelete} />
                        }
                    </InputGroup>
                </CardTitle>
            </Card>
        </Col>
    )
}